export default "__VITE_ASSET__BtDBzZm___"